import styled from 'styled-components';

export default styled.input`
  background: ${props => props.theme.input.backgroundColor};

  border: none;

  color: ${props => props.theme.input.textColor.toHex()};
  padding: ${props => props.theme.input.padding};
  transition: all 0.1s ease;
  font-size: ${props => props.theme.textSize.l};
  line-height: ${props => props.theme.lineHeight.l};

  &::placeholder {
    color: ${props => props.theme.input.textColor.toHex()};
    opacity: 0.5;
  }

  &:focus {
    border-color: ${props => props.theme.border.color.focus.toHex()};
    outline: none;
  }

  :disabled,
  &[disabled] {
    opacity: ${props => props.theme.input.disabled.opacity};
    cursor: default;
    pointer-events: none;
  }
`;
